import axios from "axios";

const URL_API_CONTENIDO = process.env.VUE_APP_API_CONTENIDO + "content/";

function obtenerPopUps() {
  return axios.get(URL_API_CONTENIDO + "getPopUps");
}

function obtenerPrecios() {
  return axios.get(URL_API_CONTENIDO + "getPrices");
}

export { obtenerPopUps, obtenerPrecios };
